import React, { useState } from 'react';
import { Alert, Sheet, Typography, Stack, Input, Select, Option, Button, Textarea, Divider, RadioGroup, Radio } from '@mui/joy';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useParams } from 'react-router-dom';
import { novoEstado, salvarEstado, salvarSku, salvaSkuLivro, salvaUnidadeLivro } from './LivrudoSlice';
import { converterDataParaString, gerarGUID, obterDataAtual } from './livrudo_helpers';

function AdicionarVendaLivroPage() {

    let { id, sku } = useParams();
    var livros = useSelector(state => state.livrudo.db.livros)
    var skus = useSelector(state => state.livrudo.db.skus)
    var dispatch = useDispatch();

    var livro = livros.filter(f => f.id == id)
    var unidade = skus.filter(s => s.sku == sku)

    React.useEffect(() => {

    }, []);
    const [form, setForm] = useState({
        sku : null,
        id : null,
        erro: "",
        preco : "",
        tarifa: "0.00",
        plataforma: "",
        observacao : "",
        data : "",
    });

    if(livro.length == 0) {
        return "Livro não encontrado"
    } else if(unidade.length == 0) {
        return "SKU não encontrado"
    }

    livro = livro[0]
    unidade = unidade[0]

    if(form.id == null) {
    setForm((prev) => ({ ...prev, ["id"]: id }));
    setForm((prev) => ({ ...prev, ["sku"]: sku }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleChangeLink = (e) => {

        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: (value) }));
    }

    const handleChangePreco = (e) => {
        const apenasNumeros = e.target.value.replace(/\D/g, '');
        const valorFormatado = (Number(apenasNumeros) / 100).toFixed(2);
        setForm((prev) => ({ ...prev, [e.target.name]: valorFormatado }))
    }


    const salva = (e) => {

        setForm((prev) => ({ ...prev, "erro": "" }))
        console.log(form)

        var error = false

        if (!form.preco || form.preco.trim().length == 0 || form.preco < 0) {
            error = "Preço inválido"
        } else if (!form.tarifa || form.tarifa.trim().length == 0 || form.tarifa < 0 ) {
            error = "Tarifa inválida"
        } else if (!form.data || form.data.trim().length == 0) {
            error = "Data inválida"
        } else if (!form.plataforma || form.plataforma.trim().length == 0) {
            error = "Plataforma inválida"
        } 

        if (error) {
            setForm((prev) => ({ ...prev, "erro": error }))
        } else {

            // Tirando atributos desnecessarios
            var { id, sku, erro, ...sobra} = form
            var { erro, redirectAfter, ...uLimpa} = unidade
            var lucro = parseFloat(sobra.preco) - parseFloat(uLimpa.preco) - parseFloat(sobra.tarifa)
            var status = "VENDIDO_AGUARDANDO_SEPARACAO"
            var u = {...uLimpa, ultimoEstado: status, status: null, venda : {
                ...sobra,
                lucro : lucro,
                retorno : lucro / parseFloat(uLimpa.preco)
            }}

            // Salvar unidade
            dispatch(salvarSku(u));
            // Lancar estado
            dispatch(salvarEstado(novoEstado({
                status : status,
                obs : ""
            })))

            setForm((prev) => ({ ...prev, "redirectAfter": true }))
        }
    };


    if (form.redirectAfter) {
        return <Navigate to={"/livrudo/livros/" + livro.id} />
    }


    return (
        <Sheet
            variant="outlined"
            sx={{
                maxWidth: 500,
                margin: 'auto',
                padding: 2,
                borderRadius: 'md',
                boxShadow: 'lg',
                backgroundColor: 'neutral.softBg',
            }}
        >

            <Typography level="h4" textAlign="center" mb={2}>
                Formulário de Venda
            </Typography>
            <Alert color="danger" sx={{ mb: 2 }}>
                {form.erro}
            </Alert>
            <Divider sx={{ marginBottom: 2 }} />
            <Stack spacing={2}>
            <Link to={"/livrudo/livros/" + livro.id}>
                <Button>Voltar</Button>
            </Link>
                <Input
                    label="SKU"
                    value={form.sku}
                    placeholder="SKU"
                    disabled={true}
                />
                <Input
                    label="Data"
                    type="date"
                    name="data"
                    value={form.data}
                    onChange={handleChange}
                    required
                />
                <Input
                    label="Preço"
                    type="number"
                    name="preco"
                    value={form.preco}
                    onChange={handleChangePreco}
                    placeholder="Preço"
                    required
                />

<Input
                    label="Tarifas"
                    type="number"
                    name="tarifa"
                    value={form.tarifa}
                    onChange={handleChangePreco}
                    placeholder="Ex: 120.00"
                    required
                />
                <Select
                    placeholder="Plataforma"
                    name="plataforma"
                    value={form.plataforma}
                    onChange={(e, value) => setForm((prev) => ({ ...prev, plataforma: value }))}
                    required
                >
                    <Option value="Amazon">Amazon</Option>
                    <Option value="OLX">OLX</Option>
                    <Option value="Enjoei">Enjoei</Option>
                    <Option value="Estante Virtual">Estante Virtual</Option>
                    <Option value="MercadoLivre">MercadoLivre</Option>
                    <Option value="Outra">Outra</Option>
                </Select>
                <Textarea
                    label="Observação"
                    name="observacao"
                    value={form.observacao}
                    onChange={handleChange}
                    minRows={3}
                    placeholder="Adicione detalhes adicionais..."
                />
                <Button onClick={salva} variant="solid" color="primary">
                    Enviar
                </Button>
            </Stack>
        </Sheet>
    );
}

export default AdicionarVendaLivroPage